module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "chapter",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('p', {
    staticClass: "chNum"
  }, [_vm._v("TWO")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("“Male, white, mid-twenties.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“You sure it’s a male, with that hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Yeah,” Dougherty said, “he’s got a beard.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty was standing on the landing looking down at Detective Carpentier. They were waiting for the assistant coroner and one of the other cops now on the scene to get the stretcher out of the black station wagon.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Carpentier said, “There’s no blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Not that I can see,” Dougherty said. “Maybe on his back?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Another flash went off, lighting up the area for a second, and the photographer, Rozovsky, said, “Maybe he broke his neck, maybe he fell.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The assistant coroner, LaPointe, was coming up the first set of stairs then, pushing past Carpentier and carrying one end of the stretcher, and he said, “Is that your expert opinion?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Oh no,” Rozovsky said, “we’ll have to wait days or weeks for an expert opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("LaPointe said, “Have you got enough pictures for "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Allo Police")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Rozovsky climbed up a few steps and took a picture of the two police cars, Carpentier’s unmarked car and the coroner’s station wagon, and said, “Not much of a crime scene, "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Allo")]), _vm._v(" will only pay if this guy turns out to be famous.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("LaPointe was at the body then and he looked up at Rozovsky, not sure if the police photographer was serious about selling pictures to the tabloid or not.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “Maybe he was drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“We’ll find out,” LaPointe said, “in a couple of weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Carpentier said, “"), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Bien.")]), _vm._v("” Then he said, “Is Dr. Michaelchuk still at the morgue?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“There was one more death,” LaPointe said. “A woman who was crushed under the fire escape, she died today in hospital. That’s thirty-seven.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Carpentier shook his head. There was nothing to say, it was overwhelming.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("LaPointe and the other cop worked in the light from Dougherty’s flashlight to get the body onto the stretcher and down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Rozovsky said, “Here comes the press,” and Dougherty looked down to see a man with curly red hair down to his shoulders and a beard getting out of an old Ford.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Logan,” Dougherty said, “he’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("From the landing Dougherty watched the reporter, Keith Logan, look at the body on the stretcher and maybe recognize the guy but then maybe not. Dougherty looked out at the city. Even halfway up Mount Royal he was looking down on the top of a lot of buildings, the big black towers of Westmount Square, Alexis Nihon Plaza and the Forum, the searchlight on top of Place Ville Marie making its slow turn around downtown.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan climbed the stairs and said, “The call said something suspicious, I thought maybe it was a bomb.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “We haven’t had a bomb in this city in two years,” and Logan said, “Last month, at the Forum, the Rolling Stones equipment truck?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Oh yeah, I forgot that,” Dougherty said. ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Rozovsky was packing up his camera and he said, “It didn’t do much damage.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“We had a quote,” Logan said, “somebody called the guy the world’s dumbest bomber.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty shrugged. He watched Carpentier standing by the station wagon talking to LaPointe.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“We used the Mick Jagger quote, ‘Why didn’t that cat leave a note?’”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “Yeah, that would’ve been good.” and Logan said, “But now you have more info.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty shrugged again and said, “Not really.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“But something, what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“It’s nothing you can put in the paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Rozovsky said, “Not in the "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Gazette")]), _vm._v(", anyway.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan said, “I don’t write for "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Midnight")]), _vm._v(" or "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Allo Police")]), _vm._v(" or any of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Okay.” Rozovsky started down the stairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan looked at Dougherty and said, “But I’d still like to know, I’m going to the Forum on Monday, what are the chances of another bomb?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“What show is that?” Rozovsky said, “Alice Cooper?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“And Dr. John,” Logan said. Then he looked at Dougherty and said, “So what do you know about the bomb?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“No one will care,” Dougherty said. “It doesn’t have anything to do with the Rolling Stones.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“The Forum?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty turned and looked at Logan and said, “It’s just a rumour, but it could be something to do with the trucking company they were using.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Oh,” Logan said, “union stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Maybe, but not here. Company’s based in Philadelphia. Anyway, it’s just a rumour.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan nodded and said okay. He looked tired. “Wasn’t even that big a deal on their tour, when they left here they got arrested in Rhode Island.”\t")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “You don’t know that guy, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan glanced at the stretcher being loaded into the station wagon and said, “I thought maybe I did, I thought I’d seen him around. Who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Don’t know yet, there was nothing on him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“You think he got mugged?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“No idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Logan said okay and turned to walk back down the stairs, saying, “I just stopped by because the call said suspicious. I’m still talking to people about the fire.” He stopped on the bottom step and looked back up at Dougherty and said, “Any word on the other two arsonists?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Okay, well, see you around.” Logan got in his car and drove away and the coroner’s station wagon left a few seconds later.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty came down the stairs and stood beside Detective Carpentier.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“It didn’t work out with the Morality Squad?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “You heard? Yeah, I don’t know, they’re just a little too …” ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Moral?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Carpentier nodded a little and said, “Well, it’s serious business, it seems like there is a new topless joint every week in this city.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Gotta check them all,” Dougherty said.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Yes.” Carpentier let it go then and Dougherty was glad. Joking around was all well and fine but Dougherty, only five years on the force, was feeling his career stall. Not that he’d had any idea about a career when he signed up — all he wanted then was to drive fast and get a little action in — but here he was, overnight shift driving a squad car and every time it looked like he might get a promotion something screwed it up.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Now Dougherty was starting to feel he screwed it up himself. He just wasn’t sure how.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("A couple of years before, when bombs were going off in Montreal every couple of weeks and when the British Trade Commissioner was kidnapped and the Deputy Premier of the province was kidnapped and murdered, Dougherty had worked pretty closely with Carpentier trying to catch a man they thought had killed five women. After that, Dougherty thought he’d get promoted to detective right away but instead he was sent back to driving patrols.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Now Carpentier was saying, “If this turns into something, I’ll give you a call,” and Dougherty said, “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Carpentier got in his car and drove away. Dougherty stood there for a few minutes looking down at the city, the strange mix of shiny new fifty-storey office towers and two-hundred-year-old stone buildings, the three bridges crossing the wide St. Lawrence River and the South Shore suburbs beyond where Dougherty’s parents had bought a duplex and settled in.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He figured it was after three a.m., checked his watch and saw it was three twenty, figured he could head back to Station Ten and by the time he wrote up his report it would be close to six, end of shift. He could get some sleep and then drive over the Champlain Bridge, have an early Sunday dinner with his folks before two days off and then days for a couple of weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Or he could finish his shift and sleep until the next one started. ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty got into his squad car and started it up and before he even put it in gear there was a call on the radio, a robbery at the Museum of Fine Arts.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Is anybody else available?” Dougherty said. “I’m still at the crime scene on the mountain.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Why are you still there, the body is long gone. Anyway you’re three blocks away, you can be at the "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("musée")]), _vm._v(" in two minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Dougherty said, “Yeah, all right, on my way,” and clipped the handset back to the big radio on the dash. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f36227","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ALittleMoreFree_Text_Final-4.vue
// module id = 75
// module chunks = 0